<template>
	<div class="user-form u-min-full-height">
		<div class="user-form__logo">
			<div :style="logoStyles"></div>
		</div>

		<div class="user-form__content">
			<p class="user-form-desc">
				하이모 홈페이지 회원이시면 별도의 가입 없이<br />
				홈페이지 계정으로 로그인하시면 됩니다.
			</p>

			<form @submit.prevent="onSubmitForm">
				<div>
					<div class="user-input-group">
						<label>
							<i class="ri-user-fill"></i>
						</label>
						<input
							v-model="userId"
							class="user-input-group__input"
							type="text"
							placeholder="아이디"
						/>
					</div>
					<div class="user-input-group">
						<label>
							<i class="ri-lock-password-fill"></i>
						</label>
						<input
							v-model="userPw"
							class="user-input-group__input"
							type="password"
							placeholder="비밀번호"
						/>
					</div>
				</div>

				<div class="has-error">
					<FormInputHint :message="errorMessage"></FormInputHint>
				</div>

				<div class="margin-box">
					<div class="auto-login">
						<label class="form-checkbox">
							<input v-model="autoLogin" type="checkbox" />
							<i class="form-icon"></i> 자동 로그인
						</label>
					</div>
				</div>

				<div class="user-form-button">
					<AppButton
						type="submit"
						color="primary"
						x-large
						block
						:disabled="isSubmit"
						>{{ isSubmit ? '로그인 중...' : '로그인' }}</AppButton
					>
				</div>
			</form>
		</div>

		<router-link class="signup-link" :to="{ name: 'signup' }"
			>아직 회원이 아니신가요?</router-link
		>

		<div class="user-form__util">
			<div>
				<router-link :to="{ name: 'findId' }">아이디 찾기</router-link>
			</div>
			<div>
				<router-link :to="{ name: 'findPassword' }">비밀번호 찾기</router-link>
			</div>
		</div>
	</div>
</template>

<script>
import AppButton from '@/components/App/AppButton';
import FormInputHint from '@/components/common/FormInputHint';
import LogoImage from '@/assets/images/common/logo.svg';

import { sendToID } from '@/utils/interface';

export default {
	components: {
		AppButton,
		FormInputHint,
	},
	data() {
		return {
			LogoImage,
			userId: '',
			userPw: '',
			errorMessage: '',
			autoLogin: false,
			isSubmit: false,
		};
	},
	computed: {
		logoStyles() {
			return {
				width: '6.25rem',
				height: '8.375rem',
				background: `url(${this.LogoImage}) no-repeat center / contain`,
			};
		},
	},
	methods: {
		async onSubmitForm() {
			if (this.isSubmit) return;

			this.isSubmit = true;

			let loginSuccess = false;

			try {
				const data = await this.$store.dispatch('userStore/userLogin', {
					userId: this.userId,
					userPw: this.userPw,
					autoLogin: this.autoLogin,
				});

				if (data.code === '00000') {
					loginSuccess = true;
					// 네이티브앱으로 로그인 아이디 전달
					sendToID(this.userId);

					this.initErrorMessage();

					// 라우터 이동 완료까지 대기
					await this.$router.push({ name: 'home' });
				} else {
					this.errorMessage =
						data.message || '아이디와 비밀번호를 다시 확인해주세요.';
				}
			} catch (error) {
				this.errorMessage = '로그인 중 오류가 발생했습니다.';
			} finally {
				// 성공이 아닐 때만 false로
				if (!loginSuccess) {
					this.isSubmit = false;
				}
			}
		},
		initErrorMessage() {
			this.errorMessage = '';
		},
	},
};
</script>

<style scoped>
.user-form {
	position: relative;
	z-index: 2;
}

.user-input-group {
	display: flex;
	flex-flow: row nowrap;
	align-items: center;
	height: 3.4375rem;
	border-radius: 3px;
	background: #fff;
	overflow: hidden;
	box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.08);
}

.user-input-group:not(:last-child) {
	margin-bottom: 1rem;
}

.user-input-group--focus {
	box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.16);
}

.user-input-group--text {
	background: none;
	box-shadow: none;
}

.user-input-group label {
	flex: 0 0 2.25rem;
	display: flex;
	justify-content: flex-end;
	align-items: center;
	height: 100%;
}

.user-input-group i {
	padding-top: 0.25em;
	color: #999;
	font-size: 0.875rem;
}

.user-input-group__input,
.user-input-group__text {
	flex: 1;
	display: flex;
	align-items: center;
	height: 100%;
	padding: 0 0.75rem;
	border: 0;
	outline: 0;
	font-size: 1rem;
	color: #222;
}

.user-input-group__input::placeholder {
	color: #ccc;
}

.user-input-group__text {
	font-weight: 500;
}

.user-form {
	display: flex;
	flex-flow: column wrap;
	align-items: center;
	padding: 0 2rem;
}

.user-form__logo {
	padding-top: 3rem;
}

.user-form__content {
	padding: 2rem 0;
	width: 100%;
}

.user-form-desc {
	margin-bottom: 1.25rem;
	color: #999;
	font-size: 1rem;
	font-weight: 300;
	letter-spacing: -0.05em;
	line-height: 1.3125;
	text-align: center;
}

.user-form__content .margin-box {
	display: flex;
	align-items: center;
	height: 3.75rem;
}

.auto-login {
	padding: 0 1.25rem;
	font-size: 1rem;
}

.signup-link {
	border-bottom: 1px solid #999;
	color: #999;
	font-size: 1rem;
}

.user-form__util {
	display: flex;
	justify-content: center;
	margin-top: auto;
	padding-bottom: 2rem;
}

.user-form__util div {
	position: relative;
}

.user-form__util div::before {
	content: '';
	position: absolute;
	left: 0;
	top: 6px;
	bottom: 6px;
	width: 1px;
	background: #999;
}

.user-form__util div:first-child::before {
	display: none;
}

.user-form__util a {
	padding: 0 1rem;
	font-size: 1rem;
}
</style>
